import React from 'react';
import { useAppState, AppState } from '../hooks/useAppState';

interface BackButtonProps {
  targetStep?: AppState['currentStep'];
}

const BackButton: React.FC<BackButtonProps> = ({ targetStep = 'home' }) => {
  const { setStep } = useAppState();

  const handleBack = () => {
    setStep(targetStep);
  };

  return (
    <button
      onClick={handleBack}
      className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-gray-600 hover:text-gray-800 transition-colors duration-200"
    >
      <svg 
        className="w-4 h-4" 
        fill="none" 
        stroke="currentColor" 
        viewBox="0 0 24 24"
      >
        <path 
          strokeLinecap="round" 
          strokeLinejoin="round" 
          strokeWidth={2} 
          d="M15 19l-7-7 7-7" 
        />
      </svg>
      Back
    </button>
  );
};

export default BackButton; 